export const FILTER_TYPE = {
  INSTITUTION: 'institution_ids',
  PATIENT_ID: 'patient_id',
  VISIT_ID: 'visit_id',
  PATIENT_NAME: 'patient_name',
};
